import React from 'react';
import { toAbsoluteUrl } from '../../utils';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

interface iEditStatusProps {
	formEditStatus: boolean;
	onSaveClick?: () => void;
	loading?: boolean;
	additionalClasses?: string
}

export const EditStatus = (props: iEditStatusProps): JSX.Element => {
	const { onSaveClick, formEditStatus, loading, additionalClasses } = props;
	const { t } = useTranslation();
	return (
		<div
			className={clsx(
				'ms-5 ms-sm-10 cursor-pointer d-flex align-items-center',
				loading ? 'cursor-not-allowed' : 'cursor-pointer',
				additionalClasses
			)}
			onClick={onSaveClick}
		>
			<img
				src={
					toAbsoluteUrl(formEditStatus
						? '/media/icons/check-circle-primary-icon.svg'
						: '/media/icons/edit-icon.svg')
				}
				height={20}
				width={20}
				alt={formEditStatus ? 'check-circle-primary-icon' : 'edit-icon'}
			/>
			<span
				className={clsx('fs-7 fw-bolder ms-2', formEditStatus ? 'text-danger' : 'text-muted' )}
			>
				{formEditStatus ? t('NEW_APPLICATION.DONE') : t('NEW_APPLICATION.EDIT')}
			</span>
		</div>
	);
};
